import '../../../common/css/base.scss';
import '../../../common/js/amap-debug'; // 此文件引用需要置顶，否则mock的时候会有问题
import Vue from 'vue';
import amapApp, { webviewInfo } from '@ali/amap-lib';
import { CommonShare } from '@ali/act-components';
import App from '../components/App.vue';
// import ACTDATA from '../../../config/config.act';
// import immersive from '../../../common/js/immersive';
// 工具函数
const isInAmap = webviewInfo.isInAmap();

function fixNativeErrorReport() {
  // eslint-disable-next-line no-underscore-dangle
  if (!window.__mapview__rightbutton) {
    // eslint-disable-next-line no-underscore-dangle
    window.__mapview__rightbutton = () => {};
  }

  if (!window.activeEvent) {
    window.activeEvent = {};
  }

  if (!window.onNativeBackEvent) {
    window.onNativeBackEvent = () => {};
  }
}

fixNativeErrorReport();

console.log(`是否公网环境${amapApp.webviewInfo.isPublic()}`);
Vue.config.productionTip = false;
Vue.config.devtools = !amapApp.webviewInfo.isPublic();

/* eslint-disable no-new */
amapApp.bridge.ready(async (res) => {
  // 埋点
  amapApp.log.initLog('gas_invited', 1);
  Vue.config.errorHandler = (error, vm, msg) => {
    console.error(error, vm, msg);// 在控制台打出错误
  };
  new Vue({
    el: '#app',
    data() {
      return {
        appInfo: res,
        isInAmap
        // tid: (res && res.tid) || null,
        // adiu: (res && res.adiu) || null,

        // immersiveHeight
      };
    },
    render: (h) => h(App),
  });
  Vue.use(CommonShare);
});
